// Istanzio secondo hook form per gestione editing dettaglio richiesta
import {useForm} from "react-hook-form";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import React, {useEffect} from "react";
import {ModalPanelForm} from "@components/Modal2023";
import DashboardDetailWF from "../dashboardWF/wf.dashboard.detail";
import {usePostSingolaRichiestaWF, usePutSingolaRichiestaWF} from "@commons/services/presenze_api/dashboard.queries";
import {Periodo} from "@commons/types";
import {toast} from "react-toastify";
import BannerWF from "../dashboardWF/comps/BannerWF";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {FPNetDate} from "@commons/types";


interface CreateWFProps {
    data: PresenzeCausaleWFRecord,

    periodo: Periodo,
    hhPreviste: number,
    hhWeekMedie: number,
    lavoratore: LavoratoreBase,
    elencoGiustificativi?: GiustificativoRecord[],
    richiesteWF?: PresenzeCausaleWFRecord[],
    day: PresenzeGiornataPlusRecord,
    onCancelEdit: () => void,
    onSaveSuccess?: (richiestaWF: PresenzeCausaleWFRecord) => void,
    ope?: 'SHOW_UPDATE' | 'DELETE' | 'UPDATE_OR_INSERT',
    isEditabile: (currentDay: FPNetDate) => boolean, //Se page è MONITOR WF, testo per ogni richiesta se editabile o meno!
}

export const UpdateOrInsertWF: React.FC<CreateWFProps> = ({
                                                              data,
                                                              periodo,
                                                              onCancelEdit,
                                                              hhPreviste,
                                                              hhWeekMedie,
                                                              lavoratore,
                                                              elencoGiustificativi,
                                                              richiesteWF,
                                                              day,
                                                              ope,
                                                              onSaveSuccess = (richiestaWF: PresenzeCausaleWFRecord) => {
                                                              },
                                                              isEditabile
                                                          }) => {
    const mutation = usePostSingolaRichiestaWF();
    const mutationUpd = usePutSingolaRichiestaWF(); // N.B. l'URI verrà risolto sulla base della richiesta passata

    const saveResource = (causale: PresenzeCausaleWFRecord) => {
        let promise;
        if (causale.wf.idWF)
            promise = mutationUpd.mutateAsync(causale);
        else
            promise = mutation.mutateAsync(causale);

        promise.then(({data: richiestaWFAggiornata}) => {
            toast(causale.wf.idWF === 0 ? 'Richiesta caricata!' : 'Richiesta aggiornata!', {type: 'success'});
            onSaveSuccess({...causale, ...richiestaWFAggiornata});
        });
    };

    const hookForm = useForm<PresenzeCausaleWFRecord>({defaultValues: data, mode: 'onChange', reValidateMode: 'onChange'});
    const {reset, control, setValue} = hookForm;
    useEffect(() => {
        reset(data)
    }, [reset, data]);

    /**
     * restituisce il mancante giustificato + il totale delle richieste di WF (solo mancante)
     * N.B. In MINUTI!!!
     * @param day
     */
    const getMancanteGiustificatoOLD = (day: PresenzeGiornataPlusRecord) => {

        let quantitaHHGiust = 0;
        let quantitaHHCausali = 0;

        if (day && elencoGiustificativi) {
            // ITERO SUI GIUSTIFICATIVI (ORARI E COPERTURA DI MANCANTE) DELLA GIORNATA
            let giustHHGiorno = day.causaliHH;
            giustHHGiorno.forEach((g) => {
                if (g && g.tipoGiu === 'ORARIO') {
                    const giust = elencoGiustificativi.find(giu => giu.codGiu === g.codGiu);
                    if (giust) {
                        if (giust.tipoOreGiu === 'M') {
                            quantitaHHGiust += (g.quantita * 60);
                        }
                    }
                }
            });

            // ITERO SULLE CAUSALI (ORARIE E COPERTURA DI MANCANTE) DELLA GIORNATA
            if (richiesteWF) {
                GestionePlus.getCausaliWFGiorno(richiesteWF, day).filter(c => c.wf.idWF !== data.wf.idWF).forEach((c) => {
                    if (c.tipoCausale === 'ORE_MANCANTI' && !c.wf.annullata && c.causaleWF?.statoIniziale !== 'RIFIUTATA') {
                        quantitaHHCausali += (c.quantita * 60);
                    }
                })
            }

            return (quantitaHHCausali + quantitaHHGiust)
        } else {
            console.warn('day e gestione non definite in fn getMancanteGiustificato()');
            return 0;
        }
    }

    return <>{data &&

        <ModalPanelForm isOpen={!!data} formControl={control} handleDismiss={onCancelEdit}
                        header={<BannerWF richiesta={data} lavoratore={lavoratore} ope={ope}/>}>

            <DashboardDetailWF
                hook={hookForm}
                richiesta={data} periodo={periodo}
                deleteRichiesta={false}
                hhPreviste={hhPreviste}
                hhWeekMedie={hhWeekMedie}
                hhMancanti={PresenzeGiornataPlusRecord.getMancanteGiustificato(day,elencoGiustificativi,richiesteWF,data.wf.idWF)}
                onCancel={onCancelEdit}
                onSave={saveResource}
                lavoratore={lavoratore}
                page="WF"
                elencoGiustificativi={elencoGiustificativi}
                day={day}
                isEditabile={isEditabile(data.giornoDt)}
            />

        </ModalPanelForm>}
    </>
}
export default UpdateOrInsertWF;